const timer = (id, deadline) => {

    function addZeroToNum (num) {
       if (num < 10 && num >= 0) {
           return `0${num}`;
       } else {
           return num;
       }
    }

    function getTimeRemaining(endtime) {
        const t = Date.parse(endtime) - Date.parse(new Date()),
              days = Math.floor(t/1000/60/60/24),
              hours = Math.floor((t/1000/60/60) % 60),
              minutes = Math.floor((t/1000/60) % 60),
              seconds = Math.floor((t/1000) % 60);

        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    }

    function setClock(selector, endtime) {
        const timer = document.querySelector(selector),
              days = timer.querySelector('#days'),
              hours = timer.querySelector('#hours'),
              minutes = timer.querySelector('#minutes'),
              seconds = timer.querySelector('#seconds'),
              timeInterval = setInterval(updateClock, 1000);
            
        updateClock();

        function updateClock() {
            const t = getTimeRemaining(endtime);
            
            days.textContent = addZeroToNum(t.days);
            hours.textContent = addZeroToNum(t.hours);
            minutes.textContent = addZeroToNum(t.minutes);
            seconds.textContent = addZeroToNum(t.seconds);

            if (t.total <= 0) {
                days.textContent = '00';
                hours.textContent = '00';
                minutes.textContent = '00';
                seconds.textContent = '00';

                clearInterval(timeInterval);
            }
        }
    }

    setClock(id, deadline);
};

export default timer;